import * as React from 'react'
import { useIntl } from 'react-intl'
import NeutralLabel from 'LuxKit/Label/NeutralLabel'
import MessagingLabel from 'LuxKit/Label/MessagingLabel'
import moment from 'moment'

const ALMOST_GONE_TAG = 'almost_gone'
const SELLING_FAST_TAG = 'selling_fast'
const TRENDING_TAG = 'trending'

const ENDING_SOON_THRESHOLD_DAYS = 7

interface Props {
  urgencyTags?: Array<string>;
  experience?: App.ExperienceOffer;
}

function getEarliestExpirationDate(experience?: App.ExperienceOffer): moment.Moment | undefined {
  const dates = [
    experience?.bookByDate,
    experience?.expirationDate,
  ]
    .filter(Boolean)
    .map((date) => moment(date))
    .filter((date) => date.isValid())

  if (!dates.length) return undefined

  return moment.min(dates)
}

function ExperienceUrgencyTag(props: Props) {
  const { urgencyTags, experience } = props

  const intl = useIntl()

  if (!urgencyTags?.length && !experience) return null

  const tags = urgencyTags ?? []

  if (tags.includes(ALMOST_GONE_TAG)) {
    return (
      <MessagingLabel variant="urgency">
        {intl.formatMessage({
          id: 'mr1jMv_mUehO3c3Ua-oa',
          defaultMessage: 'Almost gone',
        })}
      </MessagingLabel>
    )
  }

  const now = moment()
  const expirationDate = getEarliestExpirationDate(experience)
  const endingSoon = expirationDate ? !expirationDate.isBefore(now) && expirationDate.diff(now, 'days') <= ENDING_SOON_THRESHOLD_DAYS : false

  if (endingSoon) {
    return (
      <MessagingLabel variant="urgency">
        {intl.formatMessage({
          id: 'hCaG_y3T-9G9_zZtkcmT',
          defaultMessage: 'Ending soon',
        })}
      </MessagingLabel>
    )
  }

  if (tags.includes(SELLING_FAST_TAG)) {
    return (
      <MessagingLabel variant="urgency">
        {intl.formatMessage({
          id: '8zaSoYdyvcmL8GK9J2D_',
          defaultMessage: 'Selling fast',
        })}
      </MessagingLabel>
    )
  }

  if (tags.includes(TRENDING_TAG)) {
    return (
      <NeutralLabel>
        {intl.formatMessage({
          id: 'G1j_QCxN3yznUN72mDQg',
          defaultMessage: 'Trending',
        })}
      </NeutralLabel>
    )
  }

  return null
}

export default React.memo(ExperienceUrgencyTag)
